export type BridgeChoiceLayout = {
  cardWidth: number;
  cardHeight: number;
  gap: number;
  centers: number[];
};

const CHOICE_AREA_WIDTH = 1_060;

export function createBridgeChoiceLayout(choiceCount: number, centerX = 640): BridgeChoiceLayout {
  if (!Number.isInteger(choiceCount) || choiceCount < 2 || choiceCount > 5) {
    throw new Error('Yörünge Köprüsü 2–5 cevap seçeneği gerektirir.');
  }

  const gap = choiceCount <= 3 ? 24 : choiceCount === 4 ? 18 : 14;
  const maximumCardWidth = choiceCount === 2 ? 360 : choiceCount === 3 ? 320 : choiceCount === 4 ? 248 : 200;
  const cardWidth = Math.min(
    maximumCardWidth,
    Math.floor((CHOICE_AREA_WIDTH - gap * (choiceCount - 1)) / choiceCount),
  );
  const occupiedWidth = cardWidth * choiceCount + gap * (choiceCount - 1);
  const firstCenter = centerX - occupiedWidth / 2 + cardWidth / 2;

  return {
    cardWidth,
    cardHeight: 132,
    gap,
    centers: Array.from({ length: choiceCount }, (_, index) => firstCenter + index * (cardWidth + gap)),
  };
}

export function bridgeChoiceFontSize(labelLength: number, cardWidth: number, hasMedia: boolean): number {
  const availableWidth = hasMedia && cardWidth >= 280 ? cardWidth - 122 : cardWidth - 34;
  if (labelLength <= 16 && availableWidth >= 150) return 23;
  if (labelLength <= 30) return availableWidth < 120 ? 16 : 20;
  if (labelLength <= 52) return availableWidth < 120 ? 15 : 17;
  return 14;
}
